export const USABLE_PALLET_CBM = 115200 * 0.000016387064;
export const PALLET_TARE_KG = 15.88;

export type MissingReason = "weight" | "dimensions" | "itemModel";

export interface QuantitySource {
  refNum: string;
  quantity: number;
}

export interface EstimateLine {
  sku: string;
  name: string;
  quantity: number;
  weightKg: number | null;
  length: number | null;
  width: number | null;
  height: number | null;
  lineWeightKg: number | null;
  lineCbm: number | null;
  missingWeight: boolean;
  missingDimensions: boolean;
  missingItemModel: boolean;
  quantitySources: QuantitySource[];
}

export interface EstimateSummary {
  productWeightKg: number;
  totalCbm: number;
  totalCubicInches: number;
  pallets: number;
  palletWeightKg: number;
  finalWeightKg: number;
  missing: Array<{
    sku: string;
    reasons: MissingReason[];
  }>;
}

export interface SalesOrderListItem {
  id: string;
  salesOrder: string;
  salesOrderDate: string;
  shippingMethod: string | null;
  shippingAddress: Record<string, string> | null;
  status: string;
}

export interface EstimateResult {
  customer: {
    id: string;
    name: string;
  };
  salesOrders: Array<{
    id: string;
    refNum: string;
    shipDate: string;
    shippingMethod: string | null;
    shippingAddress: Record<string, string> | null;
    status: string;
  }>;
  lines: EstimateLine[];
  estimate: EstimateSummary;
}

export interface CustomerOption {
  value: string;
  label: string;
}
